import { cn } from "@/lib/utils"

function Skeleton({ className, ...props }: React.ComponentProps<"div">) {
  return (
    <div
      data-slot="skeleton"
      className={cn("animate-pulse rounded-[3px] bg-[#E8E9EB]", className)}
      {...props}
    />
  )
}

export { Skeleton }
